/** @jsx jsx */
import { jsx } from "theme-ui"
import PropTypes from "prop-types"

import { ab } from "../theme"

const ThreeColumnText = ({
  heading1,
  heading2,
  heading3,
  text1,
  text2,
  text3,
}) => (
  <div
    sx={{
      variant: "spacingContainer",
      display: "flex",
      flexDirection: ab({ _: "column", md: "row" }),
      "& > div": {
        ml: ab({ _: 0, md: "20px" }),
        width: ab({ _: "100%", md: "33%" }),
        "& > h2": {
          lineHeight: "40px",
        },
      },
    }}
  >
    <div
      sx={{
        color: "text",
      }}
    >
      <h2
        sx={{
          my: ab({ _: 2, md: 0 }),
          py: ab({ md: 3 }),
          paddingRight: ab({ md: 4 }),
          variant: "styles.h2",
          height: ab({ _: "auto", md: heading1 ? "auto" : "70px" }),
        }}
      >
        <span
          sx={{
            display: heading1 ? "block" : "none",
          }}
        >
          {heading1}
        </span>
      </h2>
      <div
        sx={{
          my: 0,
        }}
      >
        {text1}
      </div>
    </div>
    <div
      sx={{
        color: "text",
      }}
    >
      <h2
        sx={{
          my: ab({ _: 2, md: 0 }),
          py: ab({ md: 3 }),
          paddingRight: ab({ md: 4 }),
          variant: "styles.h2",
          height: ab({ _: "auto", md: heading2 ? "auto" : "70px" }),
        }}
      >
        <span
          sx={{
            display: heading2 ? "block" : "none",
          }}
        >
          {heading2}
        </span>
      </h2>
      <div
        sx={{
          my: 0,
        }}
      >
        {text2}
      </div>
    </div>
    <div
      sx={{
        color: "text",
      }}
    >
      <h2
        sx={{
          flex: 1,
          my: ab({ _: 2, md: 0 }),
          py: ab({ md: 3 }),
          paddingRight: ab({ md: 4 }),
          variant: "styles.h2",
          height: ab({ _: "auto", md: heading3 ? "auto" : "70px" }),
        }}
      >
        <span
          sx={{
            display: heading3 ? "block" : "none",
          }}
        >
          {heading3}
        </span>
      </h2>
      <div
        sx={{
          flex: 1,
          my: 0,
        }}
      >
        {text3}
      </div>
    </div>
  </div>
)

ThreeColumnText.propTypes = {
  heading1: PropTypes.string,
  heading2: PropTypes.string,
  heading3: PropTypes.string,
  text1: PropTypes.node,
  text2: PropTypes.node,
  text3: PropTypes.node,
  children: PropTypes.node,
}

export default ThreeColumnText
